import { render } from "./B2CTestimonials.vue?vue&type=template&id=611aaffa&lang=pug"
import script from "./B2CTestimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CTestimonials.vue?vue&type=script&setup=true&lang=js"

import "./B2CTestimonials.vue?vue&type=style&index=0&id=611aaffa&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__